import {HttpClient} from '@angular/common/http';
import 'rxjs/add/operator/catch';
import {Injectable} from '@angular/core';
import {ApiEndpoints} from '../ApiEndpoints';
import {ApiUtils} from '../ApiUtils';
import 'rxjs/add/operator/map';
import { User } from '../../model/user';
import { plainToClass } from 'class-transformer';
// import {SharedMethods} from "../../../util/sharedMethods";
// import {NetworkService} from "../../../util/NetworkService";
import { SharedMethods } from '../../../../util/sharedMethods-service';
import swal from 'sweetalert2';
import { Settings } from '../../model/settings';



@Injectable()
export class ApiSettingService {


  iSconnecting: boolean = false;

  // caisse: Compte;

  constructor(public apiEndpoints: ApiEndpoints, public http: HttpClient,
              public apiUtils: ApiUtils,
              // public networkService:NetworkService,
              // public sharedMethods: SharedMethods
              public sharedMethods: SharedMethods,
              ) { }

    getSetting() {

      // this.iSconnecting = true;

      return new Promise<any>(resolve => {

         this.http.get(this.apiEndpoints.URL_GET_SETTING, {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()}).subscribe(data => {
          
          resolve(data);

         },
         err => {
           this.sharedMethods.errorApiShow(err.error.code, err.error.message);
           // alert(JSON.stringify(err));
           //this.iSsaving = false;
         });

      });


    }


    update(param: Settings) {

      /* const data = {
          firebaseToken: device.firebase_token,
          browser: device.browser,
          browserVersion: device.browser_version,
          os: device.os,
          osVersion: device.os_version,
          type: device.type,
          lang: device.lang,
          countryCode: device.country_code,
          countryName: device.country_name,
          latitude: device.latitude,
          longitude: device.longitude,
          city: device.city,
          ipv4: device.ipv4,
      }; */

      return new Promise<any>(resolve => {
        this.http.patch(this.apiEndpoints.GET_URL_PATCH_SETTINGS, param,
          {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
          .subscribe((data: any) => {
              /* resolve(data);
              this.iSsaving = false; */
              resolve(data);
            },
            err => {
              this.sharedMethods.errorApiShow(err.error.code, err.error.message);
              // alert(JSON.stringify(err));
              //this.iSsaving = false;
            });
      });


  }



}
